import { EmployeesNum } from 'src/modules/common/types';

export const numberOfEmployeesToString = (numberOfEmployees: EmployeesNum): string => {
  return numberOfEmployees.replace('N_', '').replace('_', ' - ');
};
